import { apiRequest } from "./base";


export const fetchNodes = async (siteId, parentId = null, includeChildren = false, node_types=[]) => {
  console.log('fetchNodes', siteId, parentId, includeChildren, node_types);
  return apiRequest(`/nodes/${siteId}`, 'GET', null, {parent_id:parentId, include_children:includeChildren, node_types:node_types.join(',')});
};
export const createNode = async (siteId, name, type, siblings, parent=null, value = null, minValue = null, maxValue = null, unit = null, nature = null) => {

  // Validate that name doesn't contain dots
  if (name.includes('.')) {
    throw new Error('Node name cannot contain dots');
  }

  // Check for duplicate names/IDs among siblings
  let tag = name.toUpperCase().replace(/\s+/g, '_');
  if (parent) {
    let prefix = parent.tag.split('.').slice(0,-1).join('.');
    if (prefix) {
        tag = prefix + '.' + parent.id.toString() + '.' + tag;
    } else {
        tag = parent.id.toString() + '.' + tag;
    }
  }

  const hasDuplicates = siblings.some(sibling => {
    return sibling.name === name || sibling.tag === tag;
  });

  if (hasDuplicates) {
    throw new Error('A sibling node with the same name or ID already exists');
  }

  return apiRequest(`/nodes/${siteId}`, 'POST', null, {
    name,
    tag,
    type,
    parent_id: parent?.id || null,
    value,
    min_value: minValue,
    max_value: maxValue,
    unit,
    nature
  });
};

export const updateNode = async (siteId, node, siblings, name=null, value=null, minValue=null, maxValue=null, unit=null, nature=null) => {
  // Validate that name doesn't contain dots
  let updates = {
    name: name,
    value: value,
    tag: null,
    min_value: minValue,
    max_value: maxValue,
    unit: unit,
    nature: nature
  };

  if (name && name !== node.name && node.mode !== 'Syncing') {
    if (name.includes('.')) {
      throw new Error('Node name cannot contain dots');
    }

    // Check for duplicate names/IDs among siblings
    let tag = name.toUpperCase().replace(/\s+/g, '_');
    let prefix = node.tag.split('.').slice(0,-1).join('.');
    if (prefix) {
      tag = prefix + '.' + tag;
    }

    const hasDuplicates = siblings.some(sibling => {
      return sibling.name === name || sibling.tag === tag;
    });

    if (hasDuplicates) {
      throw new Error('A sibling node with the same name or ID already exists');
    }
    updates.tag = tag;
  }
  
  return apiRequest(`/nodes/${siteId}/${node.id}`, 'PUT', null, {
    name: updates.name,
    value: updates.value,
    tag: updates.tag,
    min_value: updates.min_value,
    max_value: updates.max_value,
    unit: updates.unit,
    nature: updates.nature
  });
};

export const deleteNode = async (siteId, node) => {
  return apiRequest(`/nodes/${siteId}/${node.id}`, 'DELETE');
};

export const fetchDescendants = async (siteId, nodeId, nodeType = null, mode = null) => {
  return apiRequest(`/nodes/${siteId}/${nodeId}/descendants`, 'GET', null, {node_type:nodeType, mode:mode});
};


export const fetchAssetsWithAttributes = async (siteId, nodeId, nameSearch, pageNo, pageSize ) => {
  return apiRequest(`/nodes/${siteId}/${nodeId}/assets`, 'GET', null, {name_search:nameSearch, page_no:pageNo, page_size:pageSize});
};


export const fetchPointsWithReadings = async (siteId, nodeId, nameSearch, pageNo, pageSize, mode = null, qualityRate = null, lastUpdated = null, diagnosis = null, natureFilter = null) => {
  if (lastUpdated) {
    const now = new Date();
    let cutoff;
    switch (lastUpdated) {
      case '1h':
        cutoff = new Date(now.getTime() - 60 * 60 * 1000);
        break;
      case '6h':
        cutoff = new Date(now.getTime() - 6 * 60 * 60 * 1000);
        break;
      case '12h':
        cutoff = new Date(now.getTime() - 12 * 60 * 60 * 1000);
        break;
      case '1d':
        cutoff = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        break;
      case '1w':
        cutoff = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      default:
        cutoff = null;
    }
    lastUpdated = cutoff ? cutoff.toISOString() : null;
  }
  return apiRequest(`/nodes/${siteId}/${nodeId}/points`, 'GET', null, {
    name_search: nameSearch,
    page_no: pageNo, 
    page_size: pageSize,
    mode: mode,
    quality_rate: qualityRate,
    last_updated: lastUpdated,
    diagnosis: diagnosis,
    nature_filter: natureFilter
  });
};


export const fetchAnalytics = async (siteId) => {
  const endDate = new Date();
  
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  
  return apiRequest(`/analytics/${siteId}`, 'GET', null, {
    start_date: `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}T00:00:00.000Z`,
    end_date: `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}T00:00:00.000Z`
  });
};
